<template>
  <div style="width: 100%;height: 100%;" class="body_qh_home" >
    <div class="top_bg">
      <headers pageType="home"></headers>
      <div class="search">
        <div class="wraper">
          <h2>欢迎来到民政网上办事大厅</h2>
          <p><input type="text" v-model="condition"  placeholder="搜索您想了解的政策/资讯/服务" class="text"><button @click="urlTo('userSearch',{condition:condition})"></button></p>
        </div>
      </div>
    </div>
    <div class="fixed">
      <fixedDiv></fixedDiv>
    </div>
    <div class="serverqh wraper" style="margin-top: 10px;">
      <el-row>
        <el-col :span="12"><div class="grid-content bg-purple">  <h2 class="tit">常用服务</h2></div></el-col>
        <el-col :span="12"><div class="grid-content bg-purple-light">
          <div v-if="tepmTitle!=''" class="tit" @click="showDetail()" style="color: red;font-size: 16px;text-align: right"><i class="el-icon-message-solid"></i><a href="javascript:void(0)" style="color: red" >{{tepmTitle}}</a> </div>
          <div v-else class="tit"  style="color: red;font-size: 16px;text-align: right"></div>

        </div></el-col>
      </el-row>
     <ul style="display: flex;justify-content: space-between">
        <li @click="urlTo('applyIndex')"    class="applyIndex_li"><a href="javascript:void(0)"  > <p>办事指南</p></a></li>
        <li @click="urlTo('policyServiceIndex')"  class="policyServiceIndex_li" ><a href="javascript:void(0)" ><p>政策服务</p></a></li>
        <li  @click="urlTo('payList')"   class="payList_li"><a href="javascript:void(0)"><p>资金发放查询</p></a></li>
        <li @click="urlTo('pubGroupIndex')"  class="pubItemIndex_li" ><a href="javascript:void(0)" ><p>阳光公示</p></a></li>
<!--        <li @click="urlTo('noticeIndex')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>通知公告</p></a></li>-->
        <li class="none enjoyTreatment_li" @click="urlTo('communitySearch',{code:'社区',name:'办事网点'})"   ><a href="javascript:void(0)" ><p>办事网点查询</p></a></li>
      </ul>
    </div>
    <div class="clear"></div>
    <div class="wraper">
      <div class="handle_qh">
        <h2 class="tit">我要办<span style="float: right;font-size: 12px;margin-right: 20px;padding-top: 25px;line-height: 20px;"  @click="urlTo('applyIndex')"><a href="javascript:void(0)">更多...</a></span></h2>
        <ul>
          <li><a href="javascript:void(0)" @click="urlTo('guideIndex',{service_code:'OLD',nav_name:'高龄津贴'})"><img src="../../static/images/icon15.png"><p>高龄津贴</p></a></li>
          <li>
            <el-tooltip content="残疾人生活补贴" placement="bottom">
<!--            <a href="javascript:void(0)"><img src="../../static/images/icon11_lock.png"><p>困难残疾人</p></a>-->
            </el-tooltip>
            <a href="javascript:void(0)" @click="urlTo('guideIndex',{service_code:'CLP_LIV',nav_name:'残疾人生活补贴'})"><img src="../../static/images/icon11.png"><p>残疾人生活补贴</p></a>
          </li>
          <li class="none">
            <el-tooltip content="残疾人护理补贴" placement="bottom">
<!--            <a href="javascript:void(0)"   ><img src="../../static/images/icon12_lock.png"><p>重度残疾人</p></a>-->
            </el-tooltip>
            <a href="javascript:void(0)"  @click="urlTo('guideIndex',{service_code:'CLP_HLF',nav_name:'残疾人护理补贴'})" ><img src="../../static/images/icon12.png"><p>残疾人护理补贴</p></a>
          </li>

          <li >
            <el-tooltip placement="bottom">
<!--            <a href="javascript:void(0)"   ><img src="../../static/images/icon14_lock.png"><p>孤儿</p></a>-->
            </el-tooltip>
            <a href="javascript:void(0)"  @click="urlTo('guideIndex',{service_code:'ORP',nav_name:'孤儿生活费'})" ><img src="../../static/images/icon14.png"><p>孤儿生活费</p></a>

          </li>
          <li>
            <el-tooltip  placement="bottom">
<!--            <a href="javascript:void(0)"  ><img src="../../static/images/icon13_lock.png"><p>事实无人抚养儿童</p></a>-->
            </el-tooltip>
            <a href="javascript:void(0)"  @click="urlTo('guideIndex',{service_code:'BLAN_ORP',nav_name:'事实无人抚养儿童生活费'})"><img src="../../static/images/icon13.png"><p>事实无人抚养儿童生活费</p></a>
          </li>
          <li class="none">
            <el-tooltip  >
<!--              <a href="javascript:void(0)"  ><img src="../../static/images/icon16_lock.png"><p>困境儿童</p></a>-->
            </el-tooltip>
            <a href="javascript:void(0)"  @click="urlTo('guideIndex',{service_code:'JDST',nav_name:'节地生态葬补贴'})" ><img src="../../static/new_imgs/jdst.png"><p>节地生态葬补贴</p></a>

          </li>




        </ul>
      </div>
      <div class="check_qh">
        <h2 class="tit">我要查</h2>
        <ul>
          <li><a href="javascript:void(0)" @click="urlTo('payList')"><img src="../../static/images/qh/zjff_zt.png"></a></li>
          <li><a href="javascript:void(0)" @click="urlTo('enjoyTreatment')"><img src="../../static/images/qh/dyff_zt.png"></a></li>
        </ul>
      </div>
    </div>
    <div class="clear"></div>
<!--    <div class="info wraper">-->
<!--      <h2 class="tit">民政资讯</h2>-->
<!--      <dl>-->
<!--&lt;!&ndash;      <el-tabs v-model="activeName" @tab-click="handleClick">&ndash;&gt;-->
<!--      <el-tabs v-model="activeName">-->
<!--        <el-tab-pane label="政策文件" name="zcwj">-->
<!--          <dd  v-for="(item, index) in zcwj" :key="item.data_id"><a href="javascript:void(0)" @click="gotoDetail(1,item.data_id)"  ><span>{{item.title}}</span><em>{{item.policy_date}}</em></a></dd>-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="阳光公示" name="yggs">-->
<!--          <dd  v-for="(item, index) in yggs" :key="item.id"><a href="javascript:void(0)" @click="gotoDetailYggs(2,item)"  ><span>{{item.title}}</span><em>{{item.time}}</em></a></dd>-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="通知公告" name="tzgg">-->
<!--          <dd  v-for="(item, index) in tzgg" :key="item.id"><a href="javascript:void(0)" @click="gotoDetail(3,item.id)"  ><span>{{item.title}}</span><em>{{item.time}}</em></a></dd>-->
<!--        </el-tab-pane>-->
<!--      </el-tabs>-->
<!--      </dl>-->
<!--    </div>-->
    <div  >
      <el-dialog
        :visible.sync="detailShow"
        width="50%"
        :lock-scroll="false"
       >
        <div style="color: black;text-align: center;padding-left: 10%;padding-right: 10%;padding-bottom: 20px;font-size: 24px;"> {{announcement.title}}</div>

        <el-row style="padding-bottom: 15px">
          <el-col :span="12"><div style="text-align: center" class="grid-content bg-purple">发布单位：{{announcement.party_name}}</div></el-col>
          <el-col :span="12"><div  style="text-align: center"class="grid-content bg-purple-light">发布时间：{{announcement.date}}</div></el-col>
        </el-row>
        <div style="height: 400px; overflow-y: scroll;">
        <div style="padding-top: 15px;padding-left: 10%;padding-right: 10%;border-top-style:inset;  font-size: 14px;
             line-height: 27px;
             text-indent: 30px;
             color: #909399;">
       >{{announcement.notice_content}}
        </div>
        <span  slot="footer" class="dialog-footer">

        </span>
        </div>
      </el-dialog></div>
    <div class="clear"></div>
    <footers></footers>
  </div>

</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    return {
      condition:'',
      tepmTitle:'',
      detailShow:false,
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      activeName: 'zcwj',
      infoData:{},
      announcementDetail:{},
      announcement:{},
      tzgg:[],
      zcwj:[],
      yggs:[],
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    }
  },
  mounted(){
    // this.initNews('zcwj');
    this.selectNew()
  },
  created(){
    this.initNews('zcwj');
    // var puAreaData=this.$cookies.get("areaInfo");
    // if(puAreaData){
    //     this.checkUserArea(puAreaData);
    // }else{
    //   //如果cookie中么有，那就根据openID或者用户ID查询数据库获取下
    //   var userId=this.$cookies.get("userId");
    //   if(!userId||userId=='-1'||userId==''){
    //     userId=this.$cookies.get("wuId");
    //   }
    //   var ttt=this;
    //   this.$https.post("api/pu/getPuUserAreaWeb.do",{userId:userId},response=>{
    //     if (response.status === 200 && response.data.code===200 && response.data.data !=null) {
    //       ttt.$cookies.set("puAreaData",response.data.data,"3D");
    //       ttt.checkUserArea(response.data.data);
    //     }else{
    //       //如果未设置区划，跳转过去设置区划
    //       Dialog.alert({
    //         message: '您还未设置区划，请先配置区划信息',
    //         confirmButtonColor:"#199DFA",
    //       }).then(() => {
    //         // on close
    //         // ttt.$router.push('puUserArea/publicIndex');
    //       });
    //     }
    //   })
    // }
    // var uuid=this.$cookies.get("uuid2");
    // if(uuid == null){
    //   uuid="vc_"+this.$util.uuid.uuid2();
    // }
    // this.uuid=uuid;
    // this.$cookies.set("uuid2",uuid,"3D");
    // this.vImg=process.env.API_HOST+'/api/verifyCode_ajax.do?t=' +Math.random();
  },
  methods: {
    gotoDetail(type,detail_id){  //type 1 政策文件 2 阳光公式 3 通知公告
      let path='';
      switch (type) {
        case 1:{
          path='PolicyDetail';
          break
        }
        case 2:{
          path='pubItemIndex';
          this.$router.push({path:path,query:{pubId:detail_id,type:typeCode,endDate:end_date,beginDate:begin_date,pubParty:pub_party_id,pubDesc:pubDesc,}})
          return;
        }
        case 3:{
          path='NoticeDetail';
          break
        }
        default:
          return
      }
      this.$router.push({path:path,query:{detail_id:detail_id}})
    },
    gotoDetailYggs(type,Objs){  //type 1 政策文件 2 阳光公式 3 通知公告
      let path='';
      switch (type) {
        case 1:{
          path='PolicyDetail';
          break
        }
        case 2:{
          path='pubItemIndex';
          this.$router.push({path:path,query:{pubId:Objs.id,type:Objs.typeCode,endDate:Objs.end_date,beginDate:Objs.begin_date,pubParty:Objs.pub_party_id,pubDesc:Objs.pubDesc}})
          return;
        }
        case 3:{
          path='NoticeDetail';
          break
        }
        default:
          return
      }
      this.$router.push({path:path,query:{detail_id:detail_id}})
    },
    selectNew(){
      this.$https.post("api/announcement/selectNew.do",{},response=>{
        if (response.status === 200 && response.data.code===200 && response.data.data !=null ) {
          this.announcement=response.data.data;
          if (this.announcement && this.announcement.length>0 && this.announcement.title!=''){
            if (this.announcement.title.length > 30) {
              this.tepmTitle= this.announcement.title.slice(0,30) + '...'
            }else {
              this.tepmTitle= this.announcement.title
            }
            if (this.announcement.is_call==1){
              var tepmShow=this.$cookies.get("detailShow");
              if (tepmShow=='' ||tepmShow==null){
                this.$cookies.set("detailShow",666,60*60+"s")
                this.detailShow=true;
              }

            }

          }
        }
      })
    },
    showDetail(){
      this.selectNew();
      this.detailShow=true;
    },
    initNews(type){
      // if(type=='zcwj'){
        if(this.zcwj.length<=0){
          this.$https.post("/api/policy/getPolicyList.do",{pageNum:1,pageSize:6,ic_code:'400'},response=> {
            if (response.status === 200 && response.data.code === 200) {
              this.zcwj=response.data.data.listData;
            }
          });
        }
      // }
      // if(type=='yggs'){
        if(this.yggs<=0){
          this.$https.post("api/pubItem/getPubItemIndex.do",{pageNum:1,pageSize:6},response=> {
            if (response.status === 200 && response.data.code === 200) {
              this.yggs=response.data.data;
            }
          });
        }
      // }
      // if(type=='tzgg'){
        if(this.tzgg<=0){
          this.$https.post("api/pu/info/listTzggListLimit.do",{pageNum:1,pageSize:6,ic_code:'400'},response=> {
            if (response.status === 200 && response.data.code === 200) {
              this.tzgg=response.data.data.list;
            }
          });
        // }
      }
    },
    handleClick(tab, event) {
      //异步获取数据
      this.initNews(tab.name);
    },

    onChange(index) {
      //  Notify({ type: 'primary', message: index+"_"});
      this.$router.push(index);
    },
    gotoReg(){
      this.$router.push("/peopleReg");

    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    urlTo2(url,params){
      this.$message({
        message: '暂未开放',
        type: 'warning'
      });
      // this.$router.push({path:url,query:params||{}});
    },


  }
}



</script>
<style>
  .info .el-tabs__item.is-active {
    background: url(../../static/images/tit_bg_on.png) repeat-x bottom left;
    color: #2c62ec;
    font-weight: bold;
  }
  .info .el-tabs__item  {
    width:100px;
    text-align: center;
    font-size: 18px;
    padding: 0 0px;
    margin-left: 20px;
    line-height: 65px;
    height: 65px;
  }
  .info .el-tabs__active-bar{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PublicIndex_qh.vue